export default __webpack_public_path__ + "static/media/SchoolTonic.fa87b2898671d434a02204832f8743d7.webp";